import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { I18nextProvider } from "react-i18next";
import { Navigate, Outlet, Route, Routes, useRoutes } from "react-router-dom";

import Error from "./components/error/Error";
import PrivateLayout from "./components/layout/PrivateLayout";
import PageLoader from "./components/loader/PageLoader";
import NotifyContainer from "./components/notify/NotifyContainer";
import { VerifyLogin } from "./features/authentication/components";
import { selectCurrentUser } from "./features/authentication/services";
import TermsOfServiceModal from "./features/termsOfService/components/TermsOfServiceModal";
import { useAppSelector } from "./hooks";
import i18n from "./locales/i18n";
import NotFound from "./pages/errorPages/NotFound";
import SalesLoginPage from "./pages/sales/SalesLoginPage";
import { SaleRoutes } from "./routes/sale";

const SuspenseLayout = () => (
    <Suspense fallback={<PageLoader loading={true} />}>
        <ErrorBoundary fallback={<Error />}>
            <Outlet />
        </ErrorBoundary>
    </Suspense>
);

const RootRedirect = () => {
    const currentUser = useAppSelector(selectCurrentUser);
    const orgId = currentUser?.org_id;
    return <Navigate to={orgId ? `/org/${orgId}/item` : "/login"} replace />;
};

const PrivateRoutes = () => {
    const routes = useRoutes([
        { path: "/", element: <RootRedirect /> },
        { path: "*", element: <NotFound /> },
        ...SaleRoutes,
    ]);
    return routes;
};

function App() {
    return (
        <I18nextProvider i18n={i18n}>
            <Routes>
                <Route element={<SuspenseLayout />}>
                    <Route element={<VerifyLogin />}>
                        {/* public */}
                        <Route path='/login' element={<SalesLoginPage />} />
                        {/* private */}
                        <Route element={<PrivateLayout />}>
                            <Route element={<TermsOfServiceModal />}>
                                <Route path='/*' element={<PrivateRoutes />} />
                            </Route>
                        </Route>
                    </Route>
                </Route>
            </Routes>
            <NotifyContainer />
        </I18nextProvider>
    );
}

export default App;
